import { rest } from 'msw'
import { ApiKey, ApiKeyCreateAPIRequest } from 'types/apiKeys'
import mockApiKeyResponse from '../../../__mocks__/ApiKeys/apiKeyResponse.json'
import mockApiKeys from '../../../__mocks__/ApiKeys/apiKeys.json'

const getAllApiKeys = rest.get<ApiKey[]>(`${API_URL}/api/token/withdraw`, async (req, res, ctx) => {
  return res(ctx.json(mockApiKeys))
})

const postCreateApiKey = rest.post<ApiKeyCreateAPIRequest>(
  `${API_URL}/api/v1/token`,
  async (req, res, ctx) => {
    return res(ctx.json(mockApiKeyResponse))
  }
)

export default [getAllApiKeys, postCreateApiKey]
